import moment from 'moment';
import forms from '@/libs/forms';
import VueFormGenerator from 'vue-form-generator';

export default {
  extension: {
    schema: {
      fields: [
        {
          type: 'radios',
          label: 'Do you need a extension?',
          model: 'extension_needed',
          required: true,
          styleClasses: 'col-md-12 flex-radio',
          values: [
            { name: 'Yes', value: true },
            { name: 'No', value: false },
          ],
          validator: VueFormGenerator.validators.required,
        },
      ],
    },
    options: forms.options('extension-form-', true),
  },
  extensionNeeded: {
    schema: {
      fields: [
        {
          type: 'fancyChecklist',
          label: 'Why are you requesting an Extension? (Check all that apply)',
          model: 'extension_why',
          required: true,
          stacked: true,
          values: [
            { value: 'Permits took longer than expected', text: 'Permits took longer than expected' },
            { value: 'Rehab took longer than expected', text: 'Rehab took longer than expected' },
            { value: 'Selling the property took longer than expected', text: 'Selling the property took longer than expected' },
            { value: 'Everything is on track and an extension is expected', text: 'Everything is on track and an extension is expected' },
            { value: 'Other', text: 'Other' },
          ],
          validator: VueFormGenerator.validators.required,
          visible(model) {
            try {
              return Boolean(model.extension_needed);
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'input',
          inputType: 'text',
          placeholder: 'Describe',
          model: 'extension_why_other',
          required: true,
          styleClasses: 'col-md-6',
          validator: VueFormGenerator.validators.required,
          visible(model) {
            try {
              return model.extension_why.includes('Other');
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'radios',
          label: 'Estimate for when the loan will be paid off',
          model: 'loan_paid_off',
          required: true,
          stacked: true,
          values: [
            { value: 'Less than 30 days', name: 'Less than 30 days' },
            { value: '1-3 months', name: '1-3 months' },
            { value: '4-6 months', name: '4-6 months' },
            { value: '6-9 months', name: '6-9 months' },
            { value: '9-12 months', name: '9-12 months' },
            { value: 'More than 12 months', name: 'More than 12 months' },
          ],
          validator: VueFormGenerator.validators.required,
          visible(model) {
            try {
              return Boolean(model.extension_needed);
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'radios',
          label: 'What is the current status of the property?',
          model: 'property_status',
          required: true,
          stacked: true,
          values: [
            { value: 'Rehab in progress', name: 'Rehab in progress' },
            { value: 'Listed', name: 'Listed' },
            { value: 'In escrow', name: 'In escrow' },
            { value: 'Rented', name: 'Rented' },
            { value: 'Other', name: 'Other' },
          ],
          validator: VueFormGenerator.validators.required,
        },
        {
          type: 'radios',
          label: 'Estimate when the rehab will be complete:',
          model: 'complete_rehab_estimation',
          required: true,
          stacked: true,
          values: [
            { value: 'Less than 30 days', name: 'Less than 30 days' },
            { value: '1-3 months', name: '1-3 months' },
            { value: '4-6 months', name: '4-6 months' },
            { value: 'More than 6 months', name: 'More than 6 months' },
          ],
          validator: VueFormGenerator.validators.required,
          visible(model) {
            try {
              return model.property_status === 'Rehab in progress';
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'input',
          inputType: 'text',
          placeholder: 'Describe',
          model: 'property_status_other',
          required: true,
          styleClasses: 'col-md-6',
          validator: VueFormGenerator.validators.required,
          visible(model) {
            try {
              return model.property_status === 'Other';
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'input',
          inputType: 'text',
          placeholder: 'Describe',
          model: 'exit_strategy_other',
          required: true,
          styleClasses: 'col-md-12',
          validator: VueFormGenerator.validators.required,
          visible(model) {
            try {
              return model.exit_strategy === 'Other';
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'input',
          label: 'Property Access Information',
          inputType: 'text',
          required: true,
          placeholder: 'Point of contact',
          model: 'point_of_contact',
          styleClasses: 'col-md-6',
          validator: VueFormGenerator.validators.string,
          visible(model) {
            try {
              return Boolean(model.extension_needed);
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'cleave',
          label: 'Property Access Information',
          model: 'phone_number',
          required: true,
          placeholder: 'Cell Phone',
          styleClasses: 'col-md-6',
          cleaveOptions: {
            numericOnly: true,
            blocks: [0, 3, 3, 4],
            delimiters: ['(', ') ', '-'],
          },
          pattern: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/g,
          validator: VueFormGenerator.validators.regexp,
          visible(model) {
            try {
              return Boolean(model.extension_needed);
            } catch (_) {
              return false;
            }
          },
        },
        {
          type: 'datePicker',
          label: 'What is your projected payoff date?',
          model: 'projected_payoff_date',
          required: true,
          styleClasses: 'col-md-6',
          options: {
            onlyDate: true,
            format: 'MM/DD/YYYY',
            formatted: 'll',
            color: '#3e88c9',
            buttonColor: '#3e88c9',
            minDate: moment().format('MM/DD/YYYY'),
            autoClose: true,
            label: 'Select Date',
          },
          validator: VueFormGenerator.validators.date,
          visible(model) {
            try {
              return !model.extension_needed;
            } catch (_) {
              return false;
            }
          },
        },
      ],
    },
  },
  additionalFiles: {
    schema: {
      fields: [
        {
          type: 'textArea',
          label: 'If there is anything else you would like to share with us regarding your loan status, please share below.',
          model: 'additional_information',
          required: false,
          hint: 'Max 500 characters',
          max: 500,
          rows: 4,
          validator: VueFormGenerator.validators.string,
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/extension/resources/schema.js